import { ApiFailure } from "@/components/data-display/api-failure";
import { LoadingState } from "@/components/ui/system-state";
import { classifyFailure } from "@/lib/api-failure";
import { useParams } from "react-router-dom";
import ApprovalDetailFlow from "@/features/approvals/approval-detail";
import ApprovalMissing from "@/features/approvals/approval-missing";
import { useApprovalDetail } from "@/hooks/use-approval-detail";

export default function ApprovalDetailPage() {
  const { id } = useParams();
  const { detail, status, receiptRef, loading, error, refresh } = useApprovalDetail(id!);

  // The loading branch is the shared LoadingState (components/ui/system-state)
  // rather than a page-local skeleton stack, so the approval detail announces
  // the same role/status label as every other loading surface in the app (F5).
  if (loading) {
    return <LoadingState />;
  }

  if (!detail) {
    // Only a missing approval is "not found"; a denial or a failed read says what it is.
    // The gateway answers an unknown id with a bounded 503, so only a denial is told apart here.
    if (error && classifyFailure({ reasonCode: error }) === "denied") {
      return <ApiFailure error={error} subject="this approval" onRetry={refresh} />;
    }
    return <ApprovalMissing id={id!} />;
  }

  return (
    <div>
      <div className="mb-3 flex items-center gap-2">
        <button
          type="button"
          onClick={refresh}
          className="text-xs text-muted underline hover:text-ink"
        >
          Refresh
        </button>
      </div>
      <ApprovalDetailFlow detail={detail} status={status} receiptRef={receiptRef} onDecided={refresh} />
    </div>
  );
}
